// Navigation is deliberately limited to a dedicated non-form swipe strip.
export function phaseSwipe(start:{x:number;y:number;at:number},end:{x:number;y:number;at:number},vertical:boolean):number {
 const dx=end.x-start.x,dy=end.y-start.y;
 return !vertical && end.at-start.at<900 && Math.abs(dx)>=60 && Math.abs(dx)>Math.abs(dy)*2 ? (dx<0 ? 1 : -1) : 0;
}
